<h2 *ngIf="title" 
    class="page-title"><app-highlight svgPath="/assets/images/svg/highlight.svg">{{ title }}</app-highlight></h2>
<app-carousel></app-carousel>
